module.exports = require('./helpers/bundle-url').getBundleURL('58NtB') + "logo-dark.eefe0b7f.svg";